"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getService = void 0;
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("./constants");
var service = axios_1.default.create({
    baseURL: (0, constants_1.BASE_URL)(),
});
var getService = function () {
    if (!(0, constants_1.isMobile)())
        return service;
    var token = (0, constants_1.authToken)();
    var Authorization = token ? "Bearer ".concat(token) : undefined;
    return axios_1.default.create({
        baseURL: (0, constants_1.BASE_URL)(),
        headers: {
            Authorization: Authorization,
        },
    });
};
exports.getService = getService;
service.interceptors.response.use(function (response) { return (__assign({}, response)); }, function (error) {
    console.log('>******** Error: ********<', error.response);
    return Promise.reject(error);
});
exports.default = service;
